/**
 * Galería principal + miniaturas en ficha de producto (`data-product-gallery`).
 */
export function bindProductGallery(root: HTMLElement): void {
  const main = root.querySelector<HTMLImageElement>("[data-gallery-main]");
  const thumbs = root.querySelectorAll<HTMLButtonElement>("[data-gallery-thumb]");
  if (!main || thumbs.length === 0) return;

  const setActive = (active: HTMLButtonElement): void => {
    for (const btn of thumbs) {
      btn.classList.toggle("product-detail__thumb--active", btn === active);
    }
  };

  for (const btn of thumbs) {
    btn.addEventListener("click", () => {
      const thumbImg = btn.querySelector("img");
      if (thumbImg?.src) {
        main.src = thumbImg.src;
        if (thumbImg.alt) main.alt = thumbImg.alt;
      }
      setActive(btn);
    });
  }
}

/** Enlaza todas las galerías dentro de un árbol (p. ej. `document` al cargar páginas estáticas). */
export function initProductGallery(scope: ParentNode = document): void {
  for (const el of scope.querySelectorAll<HTMLElement>("[data-product-gallery]")) {
    bindProductGallery(el);
  }
}
